import { rest } from 'msw';

const receiveSdkCommand = rest.post('/telemetry/series/:seriesId/commands', (req, res, ctx) =>
    res(ctx.status(204)),
);

export default [receiveSdkCommand];
